import { GenericObject } from "@mongez/reinforcements";
import { useSearchParams } from "@remix-run/react";
import { Filter } from "core/catalog";
import { useCallback, useRef, useState } from "react";
import { useFilters } from "./useFilters";

export function usePriceFilter(filter: Filter) {
  const { data } = filter;

  const { setFilters } = useFilters();

  const [searchParams] = useSearchParams();

  const currentMinValue = Math.floor(
    Number(searchParams.get(`minPrice`) || data.min),
  );
  const currentMaxValue = Math.floor(
    Number(searchParams.get(`maxPrice`) || data.max),
  );

  const [values, setValues] = useState<[number, number]>([
    currentMinValue,
    currentMaxValue,
  ]);

  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const updateFilter = useCallback(
    (newFilters: { [key: string]: number | null }) => {
      setFilters((prevFilters: GenericObject) => ({
        ...prevFilters,
        ...newFilters,
      }));
    },
    [setFilters],
  );

  const debouncedUpdateFilter = useCallback(
    (values: [number, number]) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        updateFilter({
          [`minPrice`]: values[0] ? values[0] : null,
          [`maxPrice`]: values[1] ? values[1] : null,
        });
      }, 500);
    },
    [updateFilter],
  );

  return {
    values,
    setValues,
    debouncedUpdateFilter,
    data,
  };
}
